import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Button } from "primeng/button";
import { UiCoreErrorRequests } from "../../models/ui-core-error-requests.model";

@Component({
  selector: "rr-ui-core-error",
  imports: [CommonModule, Button],
  templateUrl: "./ui-core-error.component.html",
  styleUrl: "./ui-core-error.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCoreErrorComponent {
  // I/O
  errorRequests = input.required<UiCoreErrorRequests>();
  errorEvent = output<void>();
  logout = output<void>();
}
